import { SocialProfileFieldsFragment } from '../../../models/graphql';
type SocialProfileTypename = SocialProfileFieldsFragment['__typename'] | undefined;
const ALL_TYPENAMES = [
  'SocialProfile',
  'TikTokSocialProfile',
  'FacebookSocialProfile',
  'InstagramSocialProfile',
  'GenericSocialProfile',
  'GoogleSocialProfile',
  'TwitterSocialProfile',
  'PinterestSocialProfile',
  'LinkedInSocialProfile',
  undefined
] as const;

const TYPENAME_VALUES: readonly SocialProfileTypename[] = ALL_TYPENAMES;

// Correct type check
type CheckAll<T extends readonly unknown[], U> = [Exclude<U, T[number]>] extends [never]
  ? [Exclude<T[number], U>] extends [never]
    ? true
    : never
  : never;

const _check: CheckAll<typeof ALL_TYPENAMES, SocialProfileTypename> = true;
// ^ This is a TS const that will throw an error in case we add new SocialProfiles to the SocialProfileFieldsFragment.
// It forces us to update const ALL_TYPES

export const isSocialProfileTypenameGuard = (value: unknown): value is SocialProfileTypename => {
  if (typeof value !== 'string') return false;
  return TYPENAME_VALUES.includes(value as SocialProfileTypename);
};
